import './js/auth/authFireBase.js';
import './js/components/modal/openModalWindow.js';
import './js/features/my-library-watched-queue/my-library-watched-queue';
import './js/features/dark-mode';
import { spinnerStart, spinnerStop } from './js/features/loader';
import './js/features/scroll_to_top';
import './js/components/modal/movie_modal-library.js';
import './js/components/modal/openModalWindow.js';
import './js/components/header/canvas-header.js';
spinnerStart();
setTimeout(spinnerStop, 1000);